var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    [
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c("Col", { attrs: { span: "24" } }, [
            _c("div", { staticClass: "global-tool-bar" }, [
              _c("div", { staticClass: "left-bar" }, [
                _c("span", { staticClass: "title" }, [_vm._v("会员资金明细")]),
              ]),
              _c("div", { staticClass: "right-bar" }),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "Form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "绑定会员" } },
                    [
                      _c("Input", {
                        attrs: { value: _vm.userPersonName, readonly: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("div", [_vm._v("资金明细")]),
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }